import Calendar from './calendar';

export default {
  Calendar,
};
